/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Default_Background_Color_BlackInputs */



/**
* | output |
* | --- |
* | "Black" |
*
* @param {Options_Display_Default_Background_Color_BlackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_default_background_color_black = /** @type {((inputs?: Options_Display_Default_Background_Color_BlackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Default_Background_Color_BlackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Noir")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schwarz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nero")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Черный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Negro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("黑色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("黒")
	if (locale === "hi") return /** @type {LocalizedString} */ ("काला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Preto")
	return /** @type {LocalizedString} */ ("Black")
});